<template>
  <v-container class="pa-0">
    <v-row
      no-gutters
      class="ma-4"
      @mouseleave="mouseDidLeave"
    >
      <v-col
        v-for="(item, index) in items"
        :key="index"
        :cols="12/itemsByRow"
      >
        <item-cell
          class="ma-1"
          :item="item"
          @itemDidSelected="$emit('itemDidSelected', $event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import ItemCell from '../cells/OptionsItemCell.vue'

  export default {
    name: 'OptionsItemsList',

    components: {
      ItemCell,
    },

    props: {
      items: Array,
    },

    computed: {
      itemsByRow () {
        if (this.$vuetify.breakpoint.smOnly) return 3
        return 4
      },
    },

    methods: {
      ...mapActions([
        'setGlancedOptionsItem',
      ]),

      mouseDidLeave () {
        this.setGlancedOptionsItem(null)
      },
    },
  }
</script>
